import { traitStakingContract } from "config";
import useIsTraitsApprovedForAll from "hooks/useIsTraitsApprovedForAll";

const useIsTraitStakingAapprovedForAll = (address?: string) =>
  useIsTraitsApprovedForAll(traitStakingContract.address, address);

export default useIsTraitStakingAapprovedForAll;
